import { Point } from "geojson";
import LongText from "../components/DataTable/renderers/LongText";
import { getActionFieldName, getEuAspectTypeName, getMeasureTypeName, getStatusImplementationName } from "./measure";
import DateTime from "../components/DataTable/renderers/DateTime";
import { IGetMeasure } from "../apis/apiSlice";


const renderEuApect = (euAspect: number) => {
  const value = getEuAspectTypeName(euAspect)
  return <LongText text={value}/>
}

const renderActionField = (value: number) => {
  return <LongText text={getActionFieldName(value)}/>
}

const renderMeasureType = (value: string) => {
  return <LongText text={getMeasureTypeName(value)}/>
}

const renderImplementationStatus = (value: string) => {
  return <LongText text={getStatusImplementationName(value)}/>
}

const renderDescription = (value: string) => {
  return <LongText text={value}/>
}

const renderName = (value: string) => {
  return <LongText text={value}/>
}

const renderCoords = (point: Point) => {
  if (point && point.coordinates && point.coordinates.length > 1){
    const x = point.coordinates[0];
    const y = point.coordinates[1];
    const value = "32" + x.toFixed() + " " + y.toFixed();
    return <LongText text={value}/>
  }  
}

const nameComparator = (item: IGetMeasure) =>
  item.name ? item.name.toLowerCase() : "";

const descComparator = (item: IGetMeasure) =>
  item.description ? item.description.toLowerCase() : "";

const euAspectComparator = (item: IGetMeasure) =>
  item.euAspect ? getEuAspectTypeName(item.euAspect) : "";

const actionFieldComparator = (item: IGetMeasure) =>
  item.actionField ? getActionFieldName(item.actionField) : "";

const measureTypeComparator = (item: IGetMeasure) =>
  item.measureType ? getMeasureTypeName(item.measureType) : "";

const implementationStatusComparator = (item: IGetMeasure) =>
  item.implementationStatus ? getStatusImplementationName(item.implementationStatus) : "";

const coordComparator = (item: IGetMeasure) => {
  const point = item.point;
   if (point && point.coordinates && point.coordinates.length > 1){
    const x = point.coordinates[0];
    const y = point.coordinates[1];
    const value = "32" + x.toFixed() + " " + y.toFixed();
    return value;
  }  
}

const renderDate = (value: string) => {
  return <DateTime jsonTime={value}/>
}

export const CREATEDBY = "createdBy";
export const UPDATEDBY = "updatedBy";

const columns = [ 
   {
    field: 'measureId',
    label: 'Maßnahmen-ID',
    render: renderName    
  },
  {
    field: 'createdInCycle',
    label: 'Erstellt in Zyklus'   
  },
  {
    field: 'updatedInCycle',
    label: 'Editiert in Zyklus'   
  },
  {
    field: 'updatedAt',
    label: 'Aktualisiert am',
    render: renderDate
  },  
  {
    field: 'name',
    label: 'Kurzbezeichnung',
    render: renderName,
    comparator: nameComparator
  },
  {
    field: 'description',
    label: 'Beschreibung',  
    render: renderDescription,
    comparator: descComparator   
  },
  {
    field: 'projectDeveloper',
    label: 'Vorhabenträger',  
    render: renderDescription,
  },
  {
    field: CREATEDBY,
    label: 'Gemeldet von',
    render: renderName
  },
   {
    field: UPDATEDBY,
    label: 'Letzter Bearbeiter',
    render: renderName
  },
  {
    field: 'euAspect',
    label: 'EU-Aspekt', 
    render: renderEuApect,
    comparator: euAspectComparator
  },
 {
    field: 'actionField',
    label: 'Handlungsfeld',
    render: renderActionField,
    comparator: actionFieldComparator
  },
  {
    field: 'measureType',
    label: 'Maßnahmentyp', 
    render: renderMeasureType,
    comparator: measureTypeComparator     
  },  
  {
    field: 'implementationStatus',
    label: 'Umsetzungsstatus', 
    render: renderImplementationStatus,
    comparator: implementationStatusComparator    
  },  
  
   {
    field: 'point',
    label: 'Koordinaten',    
    render: renderCoords,
    comparator: coordComparator     
  }
];

export default columns